/**
 * useSessionUserId — thin handle around `getSession().user_id`.
 *
 * The session payload lives in localStorage / the OS keychain (Rust
 * `keyring`) and is read synchronously; we wrap it in a hook so React
 * components stay declarative + so we can swap the underlying source
 * (BFF cookie, OS keychain) without touching every caller.
 */

import { getSession } from "@ando/core/auth";
import * as React from "react";

export function useSessionUserId(): string | null {
  // The session is hydrated from storage at app boot; once it's there it's
  // stable for the lifetime of the SPA. We still snapshot in a `useMemo`
  // so React strict mode + suspense don't re-read on every render.
  return React.useMemo(() => getSession()?.user_id ?? null, []);
}
